import { api } from 'config/default.json';

export const getBaseUrl = (): string => {
  // تشخیص خودکار بر اساس دامنه فرانت
  if (window.location.host.includes('daroog.com') || window.location.host.includes('daroog.net')) {
    return api.production;
  }
  if (window.location.host.includes('text-mining.ir')) {
    return api.test;
  }
  if (window.location.host.includes('localhost')) {
    return api.local;
  }

  // پیش‌فرض: تست
  return api.test;
}
